import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import App from './app/App.tsx';
import './styles/index.css';

// Initialise Sentry before mounting. No-op when VITE_SENTRY_DSN is not set.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment:
      (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ?? import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0, // Error capture only — no performance tracing needed for UAT
    tracePropagationTargets: [/\/api\//],
  });
}

createRoot(document.getElementById('root')!).render(<App />);
